export const ASSISTANTS = [
  {
    id: "guide",
    name: "Ayurveda Guide",
    tagline: "Your friendly guide to Ayurveda",
    desc: "Ask anything about Ayurveda, the doshas, therapies and our reviewed articles. Get clear, cited answers.",
    icon: "sparkles",
    suggestions: ["What are the three doshas?", "What is Panchakarma?", "Find articles on immunity"],
  },
  {
    id: "herbs",
    name: "Herb Advisor",
    tagline: "Herbs, uses & safety",
    desc: "Explore medicinal herbs — traditional uses, properties and, most importantly, safety and interactions.",
    icon: "leaf",
    suggestions: ["Tell me about ashwagandha safely", "Which herbs support digestion?", "Is turmeric safe with medication?"],
  },
  {
    id: "journey",
    name: "Journey Planner",
    tagline: "Plan a Kerala wellness stay",
    desc: "Plan an Ayurveda experience in Kerala — suitable therapies, what to expect, preparation and best seasons.",
    icon: "map",
    suggestions: ["Plan a relaxing 5-day Kerala retreat", "Which therapy suits stress relief?", "Best season for Panchakarma?"],
  },
];

export const getAssistant = (id) => ASSISTANTS.find((a) => a.id === id) || ASSISTANTS[0];
